import { QueryClient } from "@tanstack/react-query";

/**
 * The app-wide QueryClient, module-level (not created inline in main.tsx) so
 * non-component code can reach it — specifically the auth listener, which
 * clears the cache on sign-out: without that, user B signing in on a shared
 * browser within staleTime was served user A's cached leases/entities/profile
 * until the background refetch landed.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
